import { useRef } from 'react';

import { CardModal, CustomScrollViewProps } from 'components/card-modal';

import { CartContent } from './components/cart-content';
import { CartContentDebug } from './components/cart-content-debug';
import { CartDebugFooter } from './components/cart-content-debug/cart-debug-footer';
import { CartHeader } from './components/cart-header';
import { useCartContext } from './hooks/use-cart-context';

export const CartScreen = () => {
  const { debug } = useCartContext();
  const cartScrollView = useRef<CustomScrollViewProps>(undefined);
  return (
    <CardModal
      key="cart"
      _headerOverride={<CartHeader />}
      scrollViewRef={cartScrollView}
      scrollView
      webAnimate={false}
      standardPadding
      invertHeaderColor
      isFullScreen
      footer={debug ? <CartDebugFooter /> : undefined}
    >
      {debug ? <CartContentDebug /> : <CartContent />}
    </CardModal>
  );
};
